import { ClientsStatusReport } from 'components/Report';
import { endpoints } from 'api';

function RevisitedClientsPage() {
    return (
        <ClientsStatusReport APIEndpoint={endpoints.REVISITED_CLIENTS_REPORT} ReportName='New Revisited Clients' />
    );
}
export default RevisitedClientsPage;
